import { Component, Input, OnChanges } from '@angular/core';
import { ReportColumn } from '../../shared/data-table/data-table.component';
import {
  cancellationBreakdownSegments,
  mapCooperateRows,
  mapCooperateStackedRows,
  mapDriverMilesStackedRows,
  mapDriverRows,
  topItems,
  tripStatusSegments,
  tripsStatItems
} from '../../utils/chart-helpers';
import {
  cooperateDisplayName,
  cooperateProfileImage,
  driverDisplayName,
  driverProfileImage,
  fleetDisplayName,
  fleetProfileImage,
  fmtMiles,
  sumField
} from '../../utils/kpi-helpers';

@Component({
  selector: 'app-br-trips-tab',
  templateUrl: './trips-tab.component.html'
})
export class BrTripsTabComponent implements OnChanges {
  @Input() loading: boolean;
  @Input() error: string;
  @Input() data: any;

  statItems: any[] = [];
  statusSegments: any[] = [];
  cancellationSegments: any[] = [];
  fundingBarItems: any[] = [];
  driverBarItems: any[] = [];
  driverMilesItems: any[] = [];
  stackedFundingItems: any[] = [];
  fundingRows: any[] = [];
  fleetRows: any[] = [];
  driverRows: any[] = [];

  fundingColumns: ReportColumn[] = [
    {
      key: 'name',
      header: 'Funding Source',
      type: 'avatar',
      avatarName: (row) => cooperateDisplayName(row),
      avatarImage: (row) => cooperateProfileImage(row),
      avatarVariant: 'cooperate'
    },
    { key: 'totalJobs', header: 'Total Jobs', value: true },
    { key: 'totalCompletedJobs', header: 'Completed', value: true },
    { key: 'totalCancelledJobs', header: 'Cancelled', value: true },
    { key: 'totalCadJobs', header: 'CAD', value: true },
    { key: 'totalMiles', header: 'Miles', value: true, render: (row) => fmtMiles(row.totalMiles) }
  ];

  fleetColumns: ReportColumn[] = [
    {
      key: 'name',
      header: 'Fleet',
      type: 'avatar',
      avatarName: (row) => fleetDisplayName(row),
      avatarImage: (row) => fleetProfileImage(row),
      avatarVariant: 'driver'
    },
    { key: 'totalJobs', header: 'Total Jobs', value: true },
    { key: 'totalCompletedJobs', header: 'Completed', value: true },
    { key: 'totalCancelledJobs', header: 'Cancelled', value: true },
    { key: 'totalCadJobs', header: 'CAD', value: true },
    { key: 'totalMiles', header: 'Miles', value: true, render: (row) => fmtMiles(row.totalMiles) }
  ];

  driverColumns: ReportColumn[] = [
    {
      key: 'name',
      header: 'Driver',
      type: 'avatar',
      avatarName: (row) => driverDisplayName(row.driver),
      avatarImage: (row) => driverProfileImage(row),
      avatarVariant: 'driver'
    },
    { key: 'totalJobs', header: 'Total Jobs', value: true },
    { key: 'totalCompletedJobs', header: 'Completed', value: true },
    { key: 'totalCancelledJobs', header: 'Cancelled', value: true },
    { key: 'totalMiles', header: 'Miles', value: true, render: (row) => fmtMiles(row.totalMiles) }
  ];

  ngOnChanges() {
    if (!this.data) return;

    const cooperateKpis = this.data.cooperateKpis || [];
    const fleetKpis = this.data.fleetKpis || [];
    const driverKpis = this.data.driverKpis || [];
    const kpiCards = this.data.kpiCards || {};

    const totalTrips = kpiCards.totalTrips != null ? kpiCards.totalTrips : sumField(cooperateKpis, 'totalJobs');
    const totalCancelled = kpiCards.totalCancelled != null ? kpiCards.totalCancelled : sumField(cooperateKpis, 'totalCancelledJobs');
    const totalCompleted = kpiCards.totalCompleted != null ? kpiCards.totalCompleted : sumField(cooperateKpis, 'totalCompletedJobs');

    this.statItems = tripsStatItems(totalTrips, totalCancelled, totalCompleted);
    this.statusSegments = tripStatusSegments(totalTrips, totalCompleted, totalCancelled);
    this.cancellationSegments = cancellationBreakdownSegments(this.data.cancellationBreakdown);
    this.fundingBarItems = topItems(mapCooperateRows(cooperateKpis, 'totalJobs'));
    this.driverBarItems = topItems(mapDriverRows(driverKpis, 'totalJobs'));
    this.driverMilesItems = topItems(mapDriverMilesStackedRows(driverKpis));
    this.stackedFundingItems = topItems(mapCooperateStackedRows(cooperateKpis), 6);

    this.fundingRows = cooperateKpis;
    this.fleetRows = fleetKpis;
    this.driverRows = driverKpis;
  }
}
